<script>
import {paginationScrollTo} from "../../helpers/helpers";

export default {
    name: "SliderMixin",

    data(){
        return{
            step: 0,
            sliderHeight: 0,
            slideWidth: 0,
            trackWidth: 0,
            trackTransform: 0,
            windowInnerWidth: 0,
            disableActionButton: false
        }
    },

    created(){

        this.handleWindowInnerWidth();

        window.addEventListener('resize', this.handleWindowInnerWidth)

    },

    destroyed(){
        window.removeEventListener('resize', this.handleWindowInnerWidth);
    },

    computed: {
        initial: {
            get() { return this.slides },
            set( val ) { this.slides = val }
        },

        currentStepComponent() {
            if ( ! this.initial?.length ) return;

            let component = this.initial[ this.step ];
            return  component;

        },
    },


    watch:{

        windowInnerWidth( _current, _previous ){

            if ( _current === _previous ) return;
            new Promise( res => {
                this.handleSlideWidth();
                res();
            } ).then( () => {
                this.handleSliderHeight();
                this.handleSelected();
                this.trackTransform = `-${(+this.slideWidth + 30)* this.step}`
            } )

        }

    },

    methods: {

        handleWindowInnerWidth(){
          this.windowInnerWidth = window.innerWidth
        },

        stepUpdate( valid = false ){
            this.initial[ this.step ].valid = valid
        },

        handleTransform( type, skipTimeout = false ){

            if(
                ( type === 'increment' && this.step + 1 === this.initial.length ) ||
                ( type === 'decrement' && this.step - 1 < 0 )
            ) return;

            new Promise( res => {

                if( type === 'increment' ){

                    if( ! this.rerender ) this.$refs.stepRefs[ this.step ].isValid();

                    if( ! this.initial[ this.step ].valid ){
                       return  this.handleSliderHeight();
                    }

                }

                paginationScrollTo('.publication__heading');

                if( skipTimeout ) return res();

                setTimeout( () => {
                    res();
                }, 700 )

            } ).then(() => {

                if( type === 'increment' ){
                    ++this.step;
                }

                if( type === 'decrement' ){
                    --this.step;
                }

                this.handleSliderHeight();
                this.trackTransform = `-${(+this.slideWidth + 30)* this.step}`

            })

                .catch( ( _e ) => console.log( _e ) )

        },

        handleSliderHeight( height = 0 ){

            if( height )  return this.sliderHeight = height;

            if( this.$refs.slides ) {
                new Promise(res => {
                    res()
                }).then(() => {
                    this.sliderHeight = this.$refs.slides[this.step].clientHeight
                })
            }

        },

        handleSlideWidth(){
            if( this.$refs.slider )
                this.slideWidth = +this.$refs.slider.clientWidth;
        },

        handleSelected( val = null ){

            this.trackWidth = this.initial.length * (+this.slideWidth + 30) ;

        }


    }

}
</script>

